import React from "react";

export default function LiveTicker({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <div className="tsp-live-ticker">
      <span className="tsp-live-ticker-label">
        <span className="tsp-live-dot" /> LIVE
      </span>
      <div className="tsp-live-ticker-track">
        {items.map((item, index) => (
          <span key={`${item.team}-${index}`} className="tsp-live-ticker-item">
            {item.team} — {item.city} — {item.books} books today {index < items.length - 1 && <span className="tsp-live-ticker-sep">•</span>}
          </span>
        ))}
      </div>
    </div>
  );
}
